import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { urlEndPoint } from 'src/app/common';
import { Tier1 } from 'src/app/models/obs/tier1';
import { Tier1Service } from 'src/app/services/obs/tier1.service';
import { UploadfileService } from 'src/app/services/util/uploadfile.service';

@Component({
  selector: 'app-adm-form-intro-info',
  templateUrl: './adm-form-intro-info.component.html',
  styleUrl: './adm-form-intro-info.component.scss'
})
export class AdmFormIntroInfoComponent implements OnInit {
  idTier1: number;
  form: FormGroup;
  tier1: Tier1 = {};

  edit: boolean = false;
  idpubclasif: number;
  isUploadPdfDir: boolean = false;
  filenamePDF1: string = '';
  filenamePDF2: string = '';
  uploatedFile1: any;
  uploatedFile2: any;
  URL: string = urlEndPoint;
  dynamicUrl: string = "";

  showPdf1Controls: boolean = false;
  showPdf2Controls: boolean = false;

  constructor(
    private tier1S: Tier1Service,
    private router: Router,
    private fb: FormBuilder,
    private activedRoute: ActivatedRoute,
    private uploadS: UploadfileService,
  ) { }

  ngOnInit() {
    const params = this.activedRoute.snapshot.params;
    this.idTier1 = params['id'];
    this.dynamicUrl = this.getURI();
    this.createForm();
    this.getOneTier1(params);
  }

  createForm() {
    this.form = this.fb.group({
      id: [null],
      shorttitle: [''],
      summary: [''],
      detail: [''],
      urllistado: [null],
      doc_name_listado: [''],
      urlmetodologico: [null],
      doc_name_metodologico: ['']
    });
  }

  getURI() {
    const currentPath = window.location.pathname;
    const regex = /\/adm\/\w+\//;
    const match = currentPath.match(regex);

    if (match) {
      const dynamicUrl = match[0];
      return dynamicUrl;
    }
    return null;
  }

  verifiedPdfDirectory() {
    if (this.tier1.urllistado && this.tier1.urllistado.startsWith('/upload')) {
      this.isUploadPdfDir = true;
    } else {
      this.isUploadPdfDir = false;
    }
  }

  loadpdf() {
    if (this.tier1.doc_name_listado) {
      const pdfPath = this.tier1.doc_name_listado;
      if (pdfPath && pdfPath.trim() !== "") {
        this.filenamePDF1 = pdfPath;
        this.showPdf1Controls = true;
      }
    }

    if (this.tier1.doc_name_metodologico) {
      const pdfPath = this.tier1.doc_name_metodologico;
      if (pdfPath && pdfPath.trim() !== "") {
        this.filenamePDF2 = pdfPath;
        this.showPdf2Controls = true;
      }
    }
  }

  onPdfChange(event: any, index: number) {
    const uploadedFile = event.target.files[0];

    if (index == 1) {
      this.uploatedFile1 = uploadedFile;
      this.showPdf1Controls = true;
      this.filenamePDF1 = uploadedFile.name;
    } else if (index == 2) {
      this.uploatedFile2 = uploadedFile;
      this.showPdf2Controls = true;
      this.filenamePDF2 = uploadedFile.name;
    }
  }

  deletePdfDB(index: number) {
    let urlControlName, docNameControlName;

    if (index === 1) {
      urlControlName = 'urllistado';
      docNameControlName = 'doc_name_listado';
    } else if (index === 2) {
      urlControlName = 'urlmetodologico';
      docNameControlName = 'doc_name_metodologico';
    }

    const currentUrl = this.form.get(urlControlName).value;

    if (currentUrl) {
      const parts = currentUrl.split('/');
      const lastPart = parts[parts.length - 1];
      this.uploadS.deletedFileMet(lastPart).subscribe({
        next: res => { console.log("Se Elimino correctamente"); },
        error: err => console.error(err)
      });
    }
  }


  removePdf(index: number) {
    if (index == 1) {
      if (this.form.get('urllistado').value) {
        const confirmation = confirm('¿Estás seguro de que deseas eliminar este archivo permanentemente?');
        if (confirmation) {
          this.deletePdfDB(index);
          this.filenamePDF1 = '';
          this.uploatedFile1 = null;
          this.showPdf1Controls = false;
          this.removePdfReferenceFromDatabase(index);
        }
      }
    } else if (index == 2) {
      if (this.form.get('urlmetodologico').value) {
        const confirmation = confirm('¿Estás seguro de que deseas eliminar este archivo permanentemente?');
        if (confirmation) {
          this.deletePdfDB(index);
          this.filenamePDF2 = '';
          this.uploatedFile2 = null;
          this.showPdf2Controls = false;
          this.removePdfReferenceFromDatabase(index);
        }
      }
    }
  }

  removePdfReferenceFromDatabase(index: number) {
    if (index == 1) {
      this.form.get('urllistado').setValue(null);
      this.form.get('doc_name_listado').setValue(null);
    } else if (index == 2) {
      this.form.get('urlmetodologico').setValue(null);
      this.form.get('doc_name_metodologico').setValue(null);
    }
  }

  getOneTier1(params: any) {
    if (params.id) {
      this.tier1S.getOne(params.id).subscribe({
        next: res => {
          this.tier1 = res['data'];
          this.verifiedPdfDirectory();
          this.edit = true;
          this.loadData();
          this.loadpdf();
        },
        error: err => console.error(err)
      });
    } else {
      this.edit = false;
    }
  }

  save() {
    if (this.form.invalid) {
      console.log("Formulario inválido");
      return Object.values(this.form.controls).forEach(control => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach(control => control.markAsTouched());
        } else {
          control.markAsTouched();
        }
      });
    }


    const hasFilesToUpload = (this.uploatedFile1 != null || this.uploatedFile2 != null);

    if (hasFilesToUpload) {
      if (this.uploatedFile1 != null) {
        this.onUpload(1);
      }
      if (this.uploatedFile2 != null) {
        this.onUpload(2);
      }
    } else {
      if (this.uploatedFile1 != null) {
        this.removePdf(1);
      }
      if (this.uploatedFile2 != null) {
        this.removePdf(2);
      }
      this.saveOrUpdate();
    }
  }

  onUpload(index: number) {
    const formDataPDF = new FormData();
    const uploadedFile = index === 1 ? this.uploatedFile1 : this.uploatedFile2;
    formDataPDF.append("uploads", uploadedFile, uploadedFile.name);

    this.uploadS.uploadFileLisMet(formDataPDF).subscribe({
      next: (response: any) => {
        if (response) {
          const filenamePDF = response.filename || '';
          if (index === 1) {
            this.createOrUpdatePDF(1, 'urllistado', 'doc_name_listado', filenamePDF);
          } else if (index === 2) {
            this.createOrUpdatePDF(2, 'urlmetodologico', 'doc_name_metodologico', filenamePDF);
          }
          this.saveOrUpdate();
        } else {
          console.error('La respuesta del servidor no contiene la propiedad filename.');
        }
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

  saveOrUpdate() {
    this.edit ? this.update(this.form.value.id, this.form.value) : this.create(this.form.value);
    this.router.navigate([this.dynamicUrl + 'list/']);
  }

  create(tier1: Tier1) {
    delete tier1.id;
    this.tier1S.create(tier1).subscribe({
      next: res => {
        console.log("Se guardo");
      },
      error: err => {
        console.error(err);
      }
    });
  }

  update(id: string, tier1: Tier1) {
    delete this.tier1.id;
    this.tier1S.update(id, tier1).subscribe({
      next: res => { console.log("Se actualizo correctamente"); },
      error: err => { console.error(err); }
    });
  }

  createOrUpdatePDF(index: number, urlControlName: string, docNameControlName: string, filename: string) {
    if (index == 1) {
      this.form.get(urlControlName).setValue(`/uploads/listado_metodologico/${filename}`);
      this.form.get(docNameControlName).setValue(this.uploatedFile1 ? this.uploatedFile1.name : '');
    } else if (index == 2) {
      this.form.get(urlControlName).setValue(`/uploads/listado_metodologico/${filename}`);
      this.form.get(docNameControlName).setValue(this.uploatedFile2 ? this.uploatedFile2.name : '');
    }
  }

  loadData() {
    this.form.reset(this.tier1);
  }

  campoNoValido(campo: string) {
    return this.form.get(campo).invalid && this.form.get(campo).touched;
  }

  cancel() {
    this.router.navigate([this.dynamicUrl + 'list/']);
  }
}
